import React from 'react';
const LoaderOverlayContext = React.createContext();

export default LoaderOverlayContext;
